export const defaultVCLProvidersJSON = {
	advertising: {
		// broadsign_feed: {
		// 	enabled: false,
		// 	options: {
		// 		ad_provider: 'pearl_media',
		// 	},
		// },
		nova: {
			enabled: false,
			options: {
				dmn_operator: 'screenverse',
			},
		},
		vistar: {
			enabled: false,
			options: {
				dmn_operator: 'screenverse',
			},
		},
		mock_nova: {
			enabled: false,
			options: {},
		},
	},
	infotainment: {
		community_events: {
			enabled: false,
		},
		fashion: {
			enabled: false,
		},
		healthy_bites_images: {
			enabled: false,
		},
		inspirations: {
			enabled: false,
		},
		missing_persons: {
			enabled: false,
		},
		news_in_pictures_3_pak: {
			enabled: false,
			options: {
				monarch__category: [
					'news',
					'sports',
					'celebrity',
				].join(','),
			},
		},
		reuters_business_news: {
			enabled: false,
		},
		sports_central: {
			enabled: false,
			options: {
				monarch_league: [
					'MLB',
					'NBA',
					'NFL',
					'NHL',
					'MLS',
					'NCAAMensFootball',
					'NCAAMensFootball1aa',
					'NCAAMensBasketball',
					'PGA',
				].join(','),
			},
		},
		the_list_images: {
			enabled: false,
		},
		traffic_graphics: {
			enabled: false,
		},
	},
	settings: {
		resolution:  '1080x1920',
		allow_audio: false,
		proxied:     false,
	},
};

// Provider keys that live in the account's visual_content_loop_providers blob but
// are NOT addable content providers. mock_nova is a feature flag: it gates the
// mock_nova_* fake settings on the real 'nova' provider (see TemplateSkeleton.js)
// and has no component of its own, so adding it to a loop would create a provider
// that renders nothing.
export const nonAddableVCLProviderKeys = [
	'mock_nova',
];

export const resolutionOptions = [
	{
		label: '1920x1080',
		value: '1920x1080',
	},
	{
		label: '1080x1920',
		value: '1080x1920',
	},
];

export const advertisingFeeds = [
	// {
	// 	name:    'Broadsign Feed',
	// 	options: {
	// 		ad_provider: [
	// 			{
	// 				value: 'pearl_media',
	// 				label: 'Pearl Media',
	// 			},
	// 			{
	// 				value: 'taubman',
	// 				label: 'Taubman',
	// 			},
	// 		],
	// 	},
	// },
	{
		name:    'Nova',
		options: {
			dmn_operator: [
				{
					value: 'screenverse',
					label: 'Screenverse',
				},
			],
		},
		autoSelectOptions: [
			'dmn_operator',
		],
	},
	{
		name:    'Vistar',
		options: {
			dmn_operator: [
				{
					value: 'corner_media',
					label: 'Corner Media',
				},
				{
					value: 'liquid_outdoor',
					label: 'Liquid Outdoor',
				},
				{
					value: 'mg_malls',
					label: 'MG Malls',
				},
				{
					value: 'screenverse',
					label: 'Screenverse',
				},
			],
		},
	},
	{
		name: 'Mock Nova',
	},
];

// Applies an advertising feed's enable/disable toggle to the account's stored
// VCL blob, and stamps any option the feed fixes to a single value.
//
// Only on enable: a fixed option (Nova's dmn_operator) has exactly one valid
// value, so switching the feed on lands it there — including over a legacy
// value, which is how an account with a stale operator heals. Switching the
// feed off must leave the stored value alone.
export const applyFeedToggle = (feedJSON, feed, enabled) => {
	feedJSON['enabled'] = enabled;
	feedJSON['options'] = feedJSON['options'] || {};

	if (enabled) {
		(feed.autoSelectOptions || []).forEach((optionName) => {
			feedJSON['options'][optionName] = feed.options[optionName][0]['value'];
		});
	}

	return feedJSON;
};

export const infotainmentFeeds = [
	{
		name: 'Community Events',
	},
	{
		name: 'Fashion',
	},
	{
		name: 'Healthy Bites Images',
	},
	{
		name: 'Inspirations',
	},
	{
		name: 'Missing Persons',
	},
	{
		name:    'News In Pictures 3 Pak',
		options: {
			monarch__category: [
				{
					label: 'News',
					value: 'news',
				},
				{
					label: 'Sports',
					value: 'sports',
				},
				{
					label: 'Celebrity',
					value: 'celebrity',
				},
			],
		},
	},
	{
		name: 'Reuters Business News',
	},
	{
		name:    'Sports Central',
		options: {
			monarch_league: [
				{
					label: 'Major League Baseball',
					value: 'MLB',
				},
				{
					label: 'National Basketball Association',
					value: 'NBA',
				},
				{
					label: 'National Football League',
					value: 'NFL',
				},
				{
					label: 'National Hockey League',
					value: 'NHL',
				},
				{
					label: 'Major League Soccer',
					value: 'MLS',
				},
				{
					label: 'NCAA Mens Football',
					value: 'NCAAMensFootball',
				},
				{
					label: 'NCAA Mens Football 1AA',
					value: 'NCAAMensFootball1aa',
				},
				{
					label: 'NCAA Mens Basketball',
					value: 'NCAAMensBasketball',
				},
				{
					label: 'Professional Golfers\' Association',
					value: 'PGA',
				},
			],
		},
	},
	{
		name: 'The List Images',
	},
	{
		name: 'Traffic Graphics',
	},
];
